import React from "react";

import { dummyPresetImagesService } from "@/api/services/implementations";
import { PresetImagesService } from "@/api/services/interfaces";


export const PresetImagesContext = React.createContext<PresetImagesService>(dummyPresetImagesService);
export const PresetImagesProvider = PresetImagesContext.Provider;
export const PresetImagesConsumer = PresetImagesContext.Consumer;

interface Props {
    service: PresetImagesService;
}

export const PresetImagesContextWrapper: React.FC<Props> = ({ service, children }) => {
    return <PresetImagesProvider value={service}>{children}</PresetImagesProvider>;
};
